<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on }">
      <v-btn v-on="on" x-small>Sample Lead</v-btn>
    </template>

    <v-form lazy-validation ref="page" @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-title style="background-color: #004056" class="white--text">
          Send a sample lead?
        </v-card-title>
   
        <v-divider />

        <v-card-text class="mt-3">
          Would you like to send <strong>{{ pro.business_name }}</strong> an sample lead?
          This lead won't cost them anything but can help them get back to their account or
          help them experience a lead before a real lead is sent.
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center py-4">
          <v-btn class="mr-7" @click="close">Cancel</v-btn>
          <v-btn type="submit" color="primary">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <ErrorOverlay
      title="Error Creating Pro" v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { ErrorOverlay } from '@/components/pages'

export default {
  name: 'ExampleLeadDialog',

  props: ['pro'],

  components: { ErrorOverlay },
  
  data() {
    return {
      dialogVisible: false,

      // for error messages
      loading: false,
      error_dialog: false,
      error_message: '',
    }
  },


  methods: {
    ...mapActions('pros', ['exampleLead']),

    close() {
      this.dialogVisible = false
    },

    async submitClick() {

      this.loading = true
      const result = await this.exampleLead(this.pro)
      this.loading=false
      
      if(result.ok) {
        this.close()
        this.$emit('reload')
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    },
  },
}
</script>